import { Component } from '@angular/core';
import { Routes } from '@angular/router';

import { BaMenuService } from '../theme';
import { PAGES_MENU_ADMIN } from './pages.menu';

@Component({
    selector: 'pages',
    template: `
        <ba-sidebar></ba-sidebar>
        <ba-page-top></ba-page-top>
            <div class="al-main">
                <div class="al-content">
                    <ba-content-top></ba-content-top>
                    <router-outlet></router-outlet>
                </div>
            </div>
        <footer class="al-footer clearfix">
      
        </footer>
        <ba-back-top position="200"></ba-back-top>
    `
})
export class Pages {

    constructor(
        private _menuService: BaMenuService
    ) { }

    ngOnInit() {
        // if(localStorage.getItem('roleName') === 'administrator'){
            this._menuService.updateMenuByRoutes(<Routes>PAGES_MENU_ADMIN);
        // }
    }
}



// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/pages/pages.component.ts